export default "__VITE_ASSET__4dYl$Mj3__"